import React, { createContext, useContext } from "react";
import usePatientDataHook from "../hooks/usePatientData";

// Creamos el contexto
const PatientDataContext = createContext();

// Este es el proveedor que envolverá tu App
export const PatientDataProvider = ({ children }) => {
  const patientData = usePatientDataHook();
  return (
    <PatientDataContext.Provider value={patientData}>
      {children}
    </PatientDataContext.Provider>
  );
};

// Hook para consumir fácilmente
export const usePatientData = () => useContext(PatientDataContext);
